import { http } from '@/utils/axios'

/**
 * @msg: 获取收藏列表
 */
export function getCollectionList(data) {
    return http({
        url: http.baseUrl('zkolCollection/getList'),
        method: 'get',
        params: http.params(data)
    })
}

/**
 * @msg: 取消收藏
 */
export function cancelCollection(data) {
    return http({
        url: http.baseUrl('zkolCollection/cancel'),
        method: 'post',
        params: http.params(data),
        data: data
    })
}